"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_tracking_1 = require("react-tracking");
var lodash_1 = require("lodash");
var I18n = require("i18n-js");
var bind_1 = require("../bind");
var listing_card_1 = require("./listing_card");
var listing_row_card_1 = require("./listing_row_card");
var overflowing_row_1 = require("./overflowing_row");
var tiles_1 = require("./tiles");
var tracker_1 = require("../tracker");
var graphql_tag_1 = require("graphql-tag");
var core_link_1 = require("./core_link");
var with_mparticle_listings_1 = require("./with_mparticle_listings");
var ListingsCollection = /** @class */ (function (_super) {
    tslib_1.__extends(ListingsCollection, _super);
    function ListingsCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingsCollection.prototype.componentDidMount = function () {
        if (!this.props.loading && this.listings.length) {
            this.trackView();
        }
    };
    ListingsCollection.prototype.componentDidUpdate = function (oldProps) {
        if (this.propsDidChange(oldProps)) {
            this.trackView();
        }
    };
    ListingsCollection.prototype.trackView = function () {
        var bumps = this.props.bumpedListings || [];
        this.props.tracking.trackEvent({
            eventType: tracker_1.VIEW,
            ids: this.listings.map(function (listing) { return listing.id; }),
            context: {
                bumpedIds: bumps.map(function (listing) { return listing.id; }),
            },
        });
        if (bumps.length > 0) {
            this.props.tracking.trackEvent({
                componentName: "Bumped" + this.props.componentName,
                eventType: tracker_1.VIEW,
                ids: bumps.map(function (listing) { return listing.id; }),
            });
        }
    };
    ListingsCollection.prototype.propsDidChange = function (oldProps) {
        return !this.props.loading
            && this.props.listings.length
            && !lodash_1.isEqual(this.props.listings, oldProps.listings);
    };
    ListingsCollection.prototype.listingIsBumped = function (idx) {
        if (!this.props.bumpedListings)
            return false;
        return idx < this.props.bumpedListings.length;
    };
    Object.defineProperty(ListingsCollection.prototype, "listings", {
        get: function () {
            return (this.props.bumpedListings || []).concat(this.props.listings || []);
        },
        enumerable: true,
        configurable: true
    });
    ListingsCollection.prototype.shouldBeSingleRow = function () {
        if (this.props.displayAsRowCards)
            return false;
        return !this.props.displayAsGrid;
    };
    ListingsCollection.prototype.isEmpty = function () {
        return !this.props.loading && !this.listings.length;
    };
    ListingsCollection.prototype.renderListingCard = function (listing, idx) {
        // For tracking purposes, adjust non-bumped rows positions start at 0.
        var bumps = this.props.bumpedListings || [];
        var adjustedIdx = this.listingIsBumped(idx) ? idx : idx - bumps.length;
        if (this.props.displayAsRowCards) {
            return (React.createElement(listing_row_card_1.default, { key: listing.id, listing: listing, bumped: this.listingIsBumped(idx), position: adjustedIdx, onOfferSuccess: this.props.onOfferSuccess, displayMetadataAsOffer: true }));
        }
        return (React.createElement(listing_card_1.default, { key: listing.id, listing: listing, position: idx, displayMetadataAsOffer: true }));
    };
    ListingsCollection.prototype.renderBumpCallout = function () {
        if (!this.props.displayAsRowCards || !lodash_1.get(this.props.bumpedListings, 'length'))
            return;
        return (React.createElement(core_link_1.default, { className: "listings-collection__bump-callout", to: "/page/bump", target: "_blank", rel: "nofollow", interactionType: "BumpCallout" }, I18n.t('commons.bumpsView.header')));
    };
    ListingsCollection.prototype.renderPlaceholder = function () {
        if (this.props.displayAsRowCards)
            return React.createElement(listing_row_card_1.default, null);
        return React.createElement(listing_card_1.default, null);
    };
    ListingsCollection.prototype.renderTiles = function () {
        return (React.createElement(tiles_1.default, { singleRow: this.shouldBeSingleRow(), placeholder: this.renderPlaceholder(), expectedCount: this.props.maxCount, loading: this.props.loading, largeTiles: this.props.largeTiles && !this.props.displayAsRowCards, oneWide: this.props.displayAsRowCards, emptyState: this.props.emptyState }, this.listings.map(this.renderListingCard)));
    };
    ListingsCollection.prototype.render = function () {
        if (this.isEmpty() && !this.props.emptyState) {
            return null;
        }
        return (React.createElement(overflowing_row_1.default, { title: this.props.title, subtitle: this.props.subtitle, subtitleHtml: this.props.subtitleHtml, ledeHtml: this.props.ledeHtml, action: !this.isEmpty() && this.props.callToAction, collectionCount: this.listings.length, appendAction: this.props.displayAsGrid || this.props.displayAsRowCards, id: this.props.jumplinkSlug },
            this.renderBumpCallout(),
            this.renderTiles()));
    };
    ListingsCollection.defaultProps = {
        maxCount: 12,
        displayAsGrid: false,
        largeTiles: false,
    };
    ListingsCollection.fragments = {
        listing: graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      fragment ListingsCollection on Listing {\n        _id\n        id\n        categoryUuids\n        slug\n        title\n        description\n        listingType\n        condition {\n          displayName\n          conditionSlug\n        }\n        price {\n          amountCents\n          display\n        }\n        pricing {\n          buyerPrice {\n            display\n            currency\n            amountCents\n          }\n          originalPrice {\n            display\n          }\n          ribbon {\n            display\n          }\n        }\n        images(input: {\n          transform: \"card_square\",\n          count: 3,\n          scope: \"photos\",\n          type: \"Product\"\n        }) {\n          source\n        }\n        state\n        stateDescription\n        shipping {\n          shippingPrices {\n            shippingMethod\n            rate {\n              amountCents\n              currency\n              display\n            }\n          }\n          freeExpeditedShipping\n          localPickupOnly\n        }\n        ...mParticleListingFields\n      }\n      ", "\n    "], ["\n      fragment ListingsCollection on Listing {\n        _id\n        id\n        categoryUuids\n        slug\n        title\n        description\n        listingType\n        condition {\n          displayName\n          conditionSlug\n        }\n        price {\n          amountCents\n          display\n        }\n        pricing {\n          buyerPrice {\n            display\n            currency\n            amountCents\n          }\n          originalPrice {\n            display\n          }\n          ribbon {\n            display\n          }\n        }\n        images(input: {\n          transform: \"card_square\",\n          count: 3,\n          scope: \"photos\",\n          type: \"Product\"\n        }) {\n          source\n        }\n        state\n        stateDescription\n        shipping {\n          shippingPrices {\n            shippingMethod\n            rate {\n              amountCents\n              currency\n              display\n            }\n          }\n          freeExpeditedShipping\n          localPickupOnly\n        }\n        ...mParticleListingFields\n      }\n      ", "\n    "])), with_mparticle_listings_1.mParticleListingFields),
        loggedInFields: graphql_tag_1.default(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      fragment LoggedInFields on Listing{\n        watching\n      }\n    "], ["\n      fragment LoggedInFields on Listing{\n        watching\n      }\n    "])))
    };
    tslib_1.__decorate([
        bind_1.default
    ], ListingsCollection.prototype, "renderListingCard", null);
    ListingsCollection = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: props.componentName,
                type: tracker_1.LISTING_TYPE,
            };
        })
    ], ListingsCollection);
    return ListingsCollection;
}(React.Component));
exports.default = ListingsCollection;
var templateObject_1, templateObject_2;
//# sourceMappingURL=listings_collection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/listings_collection.js
// module id = Hy+f
// module chunks = 0 1 2 3 4 6 8 11 12 13 20